import React from 'react';

import checkedIcon from '../../assets/success-check-icon.svg';

import './styles.css';

const SignInSucess: React.FC = () => {
  return (
    <div className="success-page">
      <div className="success-background">
        <img src={checkedIcon} alt="Ícone de check" />
        <h2>Cadastro concluído</h2>
        <p>
          Falta pouco para você fazer parte da plataforma Busca Saúde! <br/> Você receberá um email quando a validação do seu perfil estiver concluída.
        </p>
        
        <div className="buttonHeaderIndex">
          <button  onClick={() => {
      window.open("https://play.google.com/store/apps/details?id=com.buscasaude", "_blank");
    }}  className="buttonGooglePlay"><i className="fab fa-google-play"></i>Google Play</button>
          {/* <button className="buttonIosStore"><i className="fab fa-apple"></i>Apple Store</button> */}
        </div>

        <a href="/" style={{color: '#FFF', fontSize: 12, marginTop: '2rem'}}>Voltar para o site</a>

      </div>
    </div>
  );
};

export default SignInSucess;